import { ProductTypeLabel } from 'src/modules/designStudio/helpers/productSelection/types';

export enum ROOF_TAGS {
  METAL = 'ROOF:METAL',
  TILE = 'ROOF:TILE',
  SHINGLE = 'ROOF:SHINGLE',
}

export const RoofTags = [ROOF_TAGS.METAL, ROOF_TAGS.TILE, ROOF_TAGS.SHINGLE];

export const ProductLabelByRoofTag: Record<ROOF_TAGS, ProductTypeLabel> = {
  [ROOF_TAGS.METAL]: ProductTypeLabel.METAL_ROOF,
  [ROOF_TAGS.TILE]: ProductTypeLabel.TILE_ROOF,
  [ROOF_TAGS.SHINGLE]: ProductTypeLabel.SHINGLE_ROOF,
};

export type EndpointVariation = {
  id: number;
  uuid: string;
  name: string;
  color: {
    name: string;
    hex: string;
  };
  facets: {
    id: string;
    facet_type: 'sizing' | 'texture' | 'style';
    value: string;
  }[];
  texture: {
    id: number;
    thumbnail: string | null;
  };
};

export type EndpointProduct = {
  id: number;
  uuid: string;
  display_name: string | null;
  label: {
    name?: string;
    value?: number;
  };
  manufacturer_url: string | null;
  name: string;
  tags: string[];
  variations: EndpointVariation[];
};

export type EndpointProvider = {
  id: number;
  name: string;
  products: EndpointProduct[];
};

export type EndpointData = EndpointProvider[];
